import React from 'react';
import { Button } from './Button';
import { Icon } from './Icon';
import { useLanguage } from '../contexts/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="relative min-h-screen md:min-h-[85vh] flex items-center justify-center overflow-hidden" data-id="element-131">
      {/* Background Image - Editorial Visibility */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/9ouEXuUddZLUXEC3rRN8Jw/IMG_6003.JPG.jpg)'
    }} data-id="element-132" />

      {/* Gradient Overlay - Left Side Only for Text Legibility */}
      {/* Right side stays clear to show the editorial image */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-transparent" data-id="element-133" />

      {/* Subtle Bottom Gradient for Depth */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" data-id="element-134" />

      {/* Very Subtle Top Vignette */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-transparent" data-id="element-135" />

      {/* Elegant Accent Line */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C5A028]/60 to-transparent" data-id="element-136" />

      {/* Content - Positioned Left to Let Image Breathe */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 md:py-20 w-full" data-id="element-137">
        <div className="max-w-2xl md:max-w-lg text-center md:text-left mx-auto md:mx-0" data-id="element-138">
          {/* Refined Badge */}
          <div className="inline-flex items-center gap-2 bg-black/50 backdrop-blur-sm border border-[#C5A028]/40 rounded-sm px-5 py-2.5 mb-6 animate-fade-in" data-id="element-139">
            <Icon name="crown" size={14} className="text-[#C5A028]" data-id="element-140" />
            <span className="text-white/90 text-xs font-medium tracking-[0.2em] uppercase" data-id="element-141">
              {t('hero.badge')}
            </span>
          </div>

          {/* Aspirational Headline */}
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white mb-5 tracking-tight leading-[1.1] animate-fade-in-delay-1 drop-shadow-lg" data-id="element-142">
            {t('hero.title1')}
            <br data-id="element-143" />
            <span className="text-[#C5A028] italic" data-id="element-144">{t('hero.title2')}</span>
          </h1>

          {/* Professional Subheadline */}
          <p className="text-base md:text-lg text-white/80 mb-6 font-light tracking-wide leading-relaxed max-w-md mx-auto md:mx-0 animate-fade-in-delay-2 drop-shadow-md" data-id="element-145">
            {t('hero.subtitle')}
          </p>

          {/* Single Primary CTA */}
          <div className="animate-fade-in-delay-3 mb-8 flex justify-center md:justify-start" data-id="element-146">
            <Button href="https://backstage.cam/u/alexaaa-narvaez" className="text-sm w-full md:w-auto shadow-2xl shadow-[#C5A028]/30" data-id="element-147">
              <span className="mr-2" data-id="element-148">{t('hero.cta')}</span>
              <Icon name="arrow-right" size={16} data-id="element-149" />
            </Button>
          </div>

          {/* Authority Indicators */}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-5 animate-fade-in-delay-4" data-id="element-150">
            <div className="flex items-center gap-3 bg-black/30 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-151">
              <div className="w-9 h-9 rounded-full bg-[#C5A028]/20 border border-[#C5A028]/40 flex items-center justify-center" data-id="element-152">
                <Icon name="star" size={16} className="text-[#C5A028]" data-id="element-153" />
              </div>
              <div data-id="element-154">
                <p className="text-white text-sm font-medium leading-tight" data-id="element-155">
                  +3M
                </p>
                <p className="text-white/60 text-xs leading-tight" data-id="element-156">
                  {t('hero.followers')}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-black/30 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-157">
              <div className="w-9 h-9 rounded-full bg-[#C5A028]/20 border border-[#C5A028]/40 flex items-center justify-center" data-id="element-158">
                <Icon name="camera" size={16} className="text-[#C5A028]" data-id="element-159" />
              </div>
              <div data-id="element-160">
                <p className="text-white text-sm font-medium leading-tight" data-id="element-161">
                  Editorial
                </p>
                <p className="text-white/60 text-xs leading-tight" data-id="element-162">
                  {t('hero.professional')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Refined Scroll Indicator */}
      <div className="absolute bottom-8 md:bottom-10 left-1/2 -translate-x-1/2 animate-bounce" data-id="element-163">
        <div className="w-5 h-8 border border-white/30 rounded-full flex justify-center pt-1.5" data-id="element-164">
          <div className="w-0.5 h-2 bg-white/50 rounded-full animate-pulse" data-id="element-165" />
        </div>
      </div>
    </section>;
}